import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { formIncludesPvqPartC } from 'helpers/form';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { nonPaymentNonFederalActionsOptions, taxTypes } from 'constants/enums/financialOptions';
import { setToStartOfMonth } from 'helpers/date';
import { REQUIRED } from 'constants/errors';
import { FinancialNonpaymentNonfederalItemModel } from '../types';

export const financialNonPaymentItemValidator: ValidateJSModel<FinancialNonpaymentNonfederalItemModel> = {

  /* ------------------------------------------------------------------
  *  - The NonPayment NonFederal subsection is unique to PVQ so it is -
  *  - unnecessary to check for formType isPVQ here.                  -
  *  ------------------------------------------------------------------ */

  TaxType: {
    hasValue: {
      validator: { inclusion: taxTypes },
    },
  },

  TaxTypeExplain: (value, attributes) => {
    if (attributes.TaxType?.value === 'Other') {
      return {
        hasValue: true,
      };
    }

    return {};
  },

  Year: (value, attributes, attributeName, options) => ({
    presence: true,
    date: {
      requireDay: false,
      requireMonth: false,
      requireYear: true,
      earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
      latest: DEFAULT_LATEST,
    },
  }),

  AmountOwed: (value, attributes) => (attributes.AmountOwedIdk?.applicable !== false ? {
    hasValue: true,
    model: {
      validator: currencyModelValidator,
    },
  } : {}),

  AmountOwedIdk: {},

  WhenPaidInFull: (value, attributes, attributeName, options) => (formIncludesPvqPartC(options?.formType) && attributes.ActionsTaken?.values?.includes('paidInFull') ? {
    presence: true,
    date: { earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST), latest: DEFAULT_LATEST, requireDay: false },
  } : {}),

  FilingDate: (value, attributes, attributeName, options) => ({
    presence: true,
    date: {
      requireDay: false,
      requireMonth: true,
      requireYear: true,
      earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
      latest: DEFAULT_LATEST,
    },
  }),

  WhenFiled: (value, attributes, attributeName, options) => (formIncludesPvqPartC(options?.formType) && attributes.ActionsTaken?.values?.includes('paidInFull') ? {
    presence: true,
    date: {
      requireDay: false,
      requireMonth: true,
      requireYear: true,
      earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
      latest: DEFAULT_LATEST,
    },
  } : {}),

  HasFiledOnTime: {},

  ActionsTaken: {
    array: {
      validator: {
        inclusion: nonPaymentNonFederalActionsOptions.getValues(),
      },
      length: { minimum: 1, message: REQUIRED }
    },
  },

  ActionsTakenReason: (value, attributes) => (attributes.ActionsTaken?.values?.includes('other') || attributes.ActionsTaken?.values?.includes('none') ? {
    hasValue: true,
  } : {}),
};
